var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"60%"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticClass:"text-center",attrs:{"slot":"header"},slot:"header"},[_vm._v("工单列表")]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.list,"columns":_vm.tableColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }